export const resetScroll = () => {
  window.scroll(0, 0);
};
